import { useState } from 'react'
import { formatMoney } from 'accounting'

import { LoadingBubbles, SidebarModal } from '@domain-group/suit-theme'

import type { CampaignQuoteTemplateModel } from '@domain-group/realhub-backend-api-types'

interface CampaignQuoteTemplateProps {
  callbacks: {
    selectCampaignQuoteTemplate: VoidFunction,
  },
  campaignQuoteTemplate: CampaignQuoteTemplateModel,
}

const CampaignQuoteTemplate = (props: CampaignQuoteTemplateProps) => {
  const {
    callbacks: {
      selectCampaignQuoteTemplate,
    },
    campaignQuoteTemplate: {
      id,
      title,
      total,
    },
  } = props

  const [loading, setLoading] = useState(false)

  return (
    <SidebarModal.Button
      iconRight={(loading
        && (
          <LoadingBubbles
            color="blue"
            style={{ display: 'inline-flex', flexShrink: 0 }}
          />
        )
      )}
      onClick={() => {
        setLoading(true)
        selectCampaignQuoteTemplate()
      }}
      showAngleIcon
      // @ts-expect-error TS2769
      subtitle={`#${id} - ${formatMoney(total)}`}
      title={title}
    />
  )
}

export default CampaignQuoteTemplate
